export const timezones: { label: string; timezone: string }[] = [
  { label: 'UTC', timezone: 'UTC' },
  { label: 'KST', timezone: 'Asia/Seoul' },
  { label: 'EST', timezone: 'US/East-Indiana' },
];

export const DATETIME_FORMAT_DEFAULT = 'yyyy/MM/dd/HH:mm';
